/* =========================================================
   CALMORA WISHLIST
   GLOBAL FINAL VERSION
   ========================================================= */

(function () {

  'use strict';

  var KEY = 'calmora_wishlist';
  var OLD_KEY = 'cal_wishlist';


  /* =======================================================
     STORAGE
     ======================================================= */

  function read(key) {

    try {

      var value = localStorage.getItem(key);

      if (!value) {
        return [];
      }

      var data = JSON.parse(value);

      return Array.isArray(data) ? data : [];

    } catch (e) {

      return [];

    }

  }


  /* =======================================================
     NORMALIZE
     ======================================================= */

  function normalize(item) {

    if (
      typeof item === 'string' ||
      typeof item === 'number'
    ) {

      return {

        id: String(item),

        productId: String(item),

        url: '',

        title: '',

        image: '',

        price: '',

        variantId: ''

      };

    }


    if (
      !item ||
      typeof item !== 'object'
    ) {

      return null;

    }


    var id = String(

      item.productId ||
      item.product_id ||
      item.id ||
      item.variantId ||
      item.variant_id ||
      item.handle ||
      item.url ||
      ''

    );


    if (!id) {
      return null;
    }


    return {

      id: id,

      productId: String(

        item.productId ||
        item.product_id ||
        item.id ||
        ''

      ),

      url: String(
        item.url || ''
      ),

      title: String(
        item.title || ''
      ),

      image: String(
        item.image || ''
      ),

      price: String(
        item.price || ''
      ),

      variantId: String(

        item.variantId ||
        item.variant_id ||
        ''

      )

    };

  }


  /* =======================================================
     GET
     ======================================================= */

  function get() {

    var all =
      read(KEY).concat(
        read(OLD_KEY)
      );


    var seen = {};

    var result = [];


    all.forEach(function (raw) {

      var item =
        normalize(raw);


      if (
        !item ||
        !item.id
      ) {

        return;

      }


      if (
        seen[item.id]
      ) {

        return;

      }


      seen[item.id] = true;

      result.push(item);

    });


    return result;

  }


  /* =======================================================
     SAVE
     ======================================================= */

  function save(list) {

    if (!Array.isArray(list)) {

      list = [];

    }


    var result = [];

    var seen = {};


    list.forEach(function (raw) {

      var item =
        normalize(raw);


      if (
        !item ||
        !item.id
      ) {

        return;

      }


      if (
        seen[item.id]
      ) {

        return;

      }


      seen[item.id] = true;

      result.push(item);

    });


    try {

      var payload =
        JSON.stringify(result);


      localStorage.setItem(
        KEY,
        payload
      );


      localStorage.setItem(
        OLD_KEY,
        payload
      );

    } catch (e) {}


    updateCounts(
      result.length
    );

    updateButtons();


    try {

      document.dispatchEvent(
        new CustomEvent(
          'wishlist:refresh'
        )
      );

    } catch (e) {}


    return result;

  }


  /* =======================================================
     HAS
     ======================================================= */

  function has(id) {

    id = String(id || '');

    if (!id) {
      return false;
    }


    return get().some(function (item) {

      return String(item.id) === id;

    });

  }


  /* =======================================================
     ADD
     ======================================================= */

  function add(item) {

    var normalized =
      normalize(item);


    if (
      !normalized ||
      !normalized.id
    ) {

      return false;

    }


    var list =
      get();


    if (
      list.some(function (existing) {

        return existing.id ===
          normalized.id;

      })
    ) {

      updateButtons();

      updateCounts(
        list.length
      );

      return false;

    }


    list.push(
      normalized
    );


    save(list);

    return true;

  }


  /* =======================================================
     REMOVE
     ======================================================= */

  function remove(id) {

    id = String(id || '');


    if (!id) {
      return false;
    }


    var list =
      get();


    var filtered =
      list.filter(function (item) {

        return String(item.id) !==
          id;

      });


    if (
      filtered.length ===
      list.length
    ) {

      return false;

    }


    save(filtered);

    return true;

  }


  /* =======================================================
     TOGGLE
     ======================================================= */

  function toggle(item) {

    var normalized =
      normalize(item);


    if (
      !normalized ||
      !normalized.id
    ) {

      return false;

    }


    if (
      has(normalized.id)
    ) {

      remove(
        normalized.id
      );

      return false;

    }


    add(normalized);

    return true;

  }


  /* =======================================================
     COUNTS
     ======================================================= */

  function updateCounts(count) {

    if (
      typeof count !== 'number'
    ) {

      count =
        get().length;

    }


    document
      .querySelectorAll(
        [
          '[data-cal-wishlist-count]',
          '[data-calmora-wishlist-count]',
          '[data-cal-wishlist-page-count]'
        ].join(',')
      )
      .forEach(function (el) {

        el.textContent =
          count;

      });

  }


  /* =======================================================
     UPDATE BUTTONS
     ======================================================= */

  function updateButtons() {

    var ids =
      get().map(function (item) {

        return String(
          item.id
        );

      });


    document
      .querySelectorAll(
        '[data-cal-wish]'
      )
      .forEach(function (button) {

        var id =
          String(
            button.getAttribute(
              'data-cal-wish'
            ) || ''
          );


        if (!id) {
          return;
        }


        var active =
          ids.indexOf(id) !== -1;


        button.classList.toggle(
          'is-wishlisted',
          active
        );


        button.classList.toggle(
          'is-wished',
          active
        );


        button.setAttribute(
          'aria-pressed',
          active
            ? 'true'
            : 'false'
        );


        button.setAttribute(
          'aria-label',
          active
            ? 'Remove from wishlist'
            : 'Add to wishlist'
        );


        button.setAttribute(
          'title',
          active
            ? 'Remove from wishlist'
            : 'Add to wishlist'
        );


        var svg =
          button.querySelector(
            'svg'
          );


        if (svg) {

          svg.setAttribute(
            'fill',
            active
              ? '#E70C65'
              : 'none'
          );


          svg.setAttribute(
            'stroke',
            active
              ? '#E70C65'
              : 'currentColor'
          );

        }

      });

  }


  /* =======================================================
     READ BUTTON
     ======================================================= */

  function buttonData(button) {

    return {

      id:
        button.getAttribute(
          'data-cal-wish'
        ) || '',

      productId:
        button.getAttribute(
          'data-cal-wish-product'
        ) || '',

      url:
        button.getAttribute(
          'data-cal-wish-url'
        ) || '',

      title:
        button.getAttribute(
          'data-cal-wish-title'
        ) || '',

      image:
        button.getAttribute(
          'data-cal-wish-image'
        ) || '',

      price:
        button.getAttribute(
          'data-cal-wish-price'
        ) || '',

      variantId:
        button.getAttribute(
          'data-cal-wish-variant'
        ) || ''

    };

  }


  /* =======================================================
     CLICK
     ======================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var button =
        event.target.closest(
          '[data-cal-wish]'
        );


      if (!button) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      var item =
        buttonData(button);


      if (!item.id) {

        console.warn(
          'Calmora Wishlist: product ID missing'
        );

        return;

      }


      var active =
        toggle(item);


      button.classList.remove(
        'cal-wishlist-pop'
      );


      void button.offsetWidth;


      button.classList.add(
        'cal-wishlist-pop'
      );


      setTimeout(
        function () {

          button.classList.remove(
            'cal-wishlist-pop'
          );

        },
        350
      );


      updateButtons();

      updateCounts();

    },
    true
  );


  /* =======================================================
     API
     ======================================================= */

  window.CalmoraWishlist = {

    get: get,

    save: save,

    has: has,

    add: add,

    remove: remove,

    toggle: toggle,

    count: function () {

      return get().length;

    },

    clear: function () {

      save([]);

    },

    refresh: function () {

      updateCounts();

      updateButtons();

    },

    debug: function () {

      console.log(
        'CALMORA WISHLIST'
      );

      console.log(
        'CURRENT:',
        read(KEY)
      );

      console.log(
        'OLD:',
        read(OLD_KEY)
      );

      console.log(
        'FINAL:',
        get()
      );

      console.log(
        'COUNT:',
        get().length
      );

      return get();

    }

  };


  /* =======================================================
     INIT
     ======================================================= */

  function init() {

    updateCounts();

    updateButtons();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /* =======================================================
     STORAGE SYNC
     ======================================================= */

  window.addEventListener(
    'storage',
    function (event) {

      if (
        event.key === KEY ||
        event.key === OLD_KEY
      ) {

        init();

      }

    }
  );


  document.addEventListener(
    'wishlist:refresh',
    function () {

      init();

    }
  );


})();